import { HomeOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Breadcrumb } from 'antd';
import { truncate } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { BrandedPath, Link } from '../TypedRoute';
import { useBreadcrumbs } from './BreadcrumbContext';

const BreadcrumbStyled = styled(Breadcrumb)`
  .ant-breadcrumb-link > a {
    color: rgba(0, 0, 0, 0.88);
    text-decoration: ${({ theme }) => theme.breadcrumbTextDecoration};
    cursor: pointer;
    &:hover {
      color: rgba(0, 0, 0, 0.88);
      text-decoration: underline;
    }
  }
  .ant-breadcrumb-separator {
    color: rgba(0, 0, 0, 0.66);
  }
`;
const getDesiderateLength = (areFew?: boolean) => {
  return areFew ? 90 : 45;
};
const textForAria = (title: React.ReactNode, areFew?: boolean) => {
  const length = getDesiderateLength(areFew);
  return typeof title === 'string' && title.length > length ? title : undefined;
};
const truncateTitle = (title: React.ReactNode, areFew?: boolean) => {
  const length = getDesiderateLength(areFew);
  return typeof title === 'string'
    ? truncate(title, { length: length })
    : title;
};

export interface IBreadcrumbsProps {}

// TODO prompt per prevenire la perdita in caso di pressione accidentale durante l'edit
/**
 * Componente che visualizza l'elenco dei breadcrumb registrati.
 */
export function Breadcrumbs(props: IBreadcrumbsProps) {
  const items = useBreadcrumbs();
  const { t } = useTranslation();
  // se ci sono pochi elementi facciamo il titolo più lungo
  const areFew: boolean = items.length < 3;

  const breadcrumbItems = [
    {
      title: (
        <Link
          to={'/' as BrandedPath}
          aria-label={t('router.breadcrumbs.home-aria', 'Home')}
        >
          <HomeOutlined aria-hidden />
        </Link>
      ),
    },
    ...items.map((b, i) => {
      return {
        key: b.path ?? b.key,
        title:
          b.path !== undefined && items.length - 1 !== i ? (
            <Link title={textForAria(b.title, areFew)} to={b.path}>
              {truncateTitle(b.title, areFew)}
            </Link>
          ) : (
            <span aria-current="page" title={textForAria(b.title, areFew)}>
              {truncateTitle(b.title, areFew)}
            </span>
          ),
      };
    }),
  ];

  return (
    <BreadcrumbStyled
      aria-label={t(
        'router.breadcrumbs.nav-aria-label',
        'navigazione briciole di pane',
      )}
      items={breadcrumbItems}
    />
  );
}
